import { Tooltip, makeStyles } from '@material-ui/core';
import React from 'react';

// eslint-disable-next-line camelcase
import AcceptSeePatientSuggestionButton from 'src/myDayToday/components/AcceptSeePatientSuggestionButton';

type SeePatientNowButtonProps = {
  seePatientDisabledReason?: string | null;
  seePatientRequestId?: string | null;
};

/**
 * Button to accept an alternative request from the pop in queue. An alternative request is one that:
 *   - is for a follow-up visit
 *   - can be accepted by the provider
 *   - is not already being suggested next to the provider
 */
export const SeePatientNowButton = ({
  seePatientDisabledReason,
  seePatientRequestId,
}: SeePatientNowButtonProps) => {
  const styles = useStyles();

  return (
    <Tooltip title={seePatientDisabledReason || ''}>
      <div className={styles.seePatientButtonWrapper}>
        {/* Buttons in a disabled state block onHover events from making their way up into the tooltip component
            so we add an extra div here to make the tooltip work correctly, even when the button is disabled. */}
        <AcceptSeePatientSuggestionButton
          disabled={!!seePatientDisabledReason}
          requestId={seePatientRequestId}
        />
      </div>
    </Tooltip>
  );
};

const useStyles = makeStyles({
  seePatientButtonWrapper: {
    width: 'fit-content',
  },
});
